import { NFTTYPE } from '../constants/bakery/nft'
import {
    getCarNFTMasterContract,
    getPokerCardMasterContract,
    getDoggyNFTContract,
    getBarkingNFTContract,
    getDoggyEquipmentContract,
    getMatrixPlusBoxContract
} from '../sushi/utils'
import { getBakeMuskMixerContract } from '../sushi/bakeMuskMixer'
import { getMuskUsmLandContract } from '../sushi/muskUsmLand'
import { getSellNFTsContract } from '../sushi/sellNFTs'

export function getGameNftMasterContract(type: string,sushi: any){
    let contract
    switch (type) {
        case NFTTYPE.CAR:
            contract = getCarNFTMasterContract(sushi)
            break
        case NFTTYPE.POKER:
            contract = getPokerCardMasterContract(sushi)
            break
        case NFTTYPE.DOGGIES:
            contract = getDoggyNFTContract(sushi)
            break
        case NFTTYPE.BARKING:
            contract = getBarkingNFTContract(sushi)
            break
        case NFTTYPE.EQUIPMENT:
            contract = getDoggyEquipmentContract(sushi)
            break
        case NFTTYPE.MATRIX:
          contract = getMatrixPlusBoxContract(sushi)
          break
        case NFTTYPE.BAKEMUSKMIXER:
            contract = getBakeMuskMixerContract(sushi)
        break
        case NFTTYPE.MUSKUSMLAND:
            contract = getMuskUsmLandContract(sushi)
        break
        case NFTTYPE.GAMEACE:
            contract = getSellNFTsContract(sushi)
            break
        default:
            break
    }
    return contract
}